<div class="flex flex-wrap mt-8 justify-start justify-center lg:gap-12 items-center ">
    <div *ngFor="let donor of donors" class="flex flex-col items-center p-2 w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/6">

        @if(donor.sponsorUrl && donor.sponsorUrl.trim() !== '')
        {
        <a [href]="getSafeUri(donor.sponsorUrl)" target='_blank' rel="noopener noreferrer"
            class="flex flex-col items-center">
            @if(donor.imageUrl && donor.imageUrl.trim() !== '')
            {
            <img [src]="absoluteMediaUriService.getAbsoluteMediaUri(donor.imageUrl)" [alt]="donor.name + ' Logo'"
                class="w-[120px] h-[120px] object-contain">
            @if(donor.displayName)
            {
            <p class="text-[14px] text-gray-500 mt-2 font-medium whitespace-nowrap ">
                {{donor.name}}
            </p>
            }
            }@else{
            <p class="text-[14px] text-gray-500 mt-2 font-medium whitespace-nowrap ">
                {{donor.name}}
            </p>
            }
        </a>
        }@else{
        @if(donor.imageUrl && donor.imageUrl.trim() !== '')
        {
        <div class="flex flex-col items-center">
            <img [src]="absoluteMediaUriService.getAbsoluteMediaUri(donor.imageUrl)" [alt]="donor.name + ' Logo'"
                class="w-[120px] h-[120px] object-contain">
            @if(donor.displayName)
            {
            <p class="text-[14px] text-gray-500 mt-2 font-medium whitespace-nowrap ">
                {{donor.name}}
            </p>
            }
        </div>
        }@else{
        <div class="flex justify-center">
            <p class="text-[14px] text-gray-500 mt-2 font-medium whitespace-nowrap ">
                {{donor.name}}
            </p>
        </div>

        }
        }



    </div>
</div>